<template>
  <div class="printable-porfolio">
    <!--Initial Tittle-->
    <!-- min-height: 1062px; -->
    <div class="cover-page">
      <img src="/static/logo.svg" class="header-logo">
      <p class="cover-page-tittle">Análisis de portafolio de inversión</p>
    </div>
    <!-- OverviewStarts -->
    <!-- Blue Section -->
    <div class="new-page first-page">
      <div id="content">
        <div id="pageFooter"> </div>
      </div>
      <print-tittle tittle="ANÁLISIS DE PORTAFOLIO DE INVERSIÓN" tittleColor="#2873de"></print-tittle>
      <portfolio-overview :printableVersion="true" :externalMarketInformationTitleSpan="9" :externalmarketInformationSpan="15"></portfolio-overview>
    </div>
    <!-- Grey Section -->
    <div v-if="portfolioAnalysis.fondosRF.amount > 0" class="new-page second-page">
      <print-tittle tittle="FONDOS DE RENTA FIJA" tittleColor="#C2BFE0"></print-tittle>
      <fondos-rf :printableVersion="true"></fondos-rf>
    </div>
    <!-- Details -->
    <div v-for="(investment, index) in portfolioAnalysis.fondosRF.investments" :key="index" class="new-page">
      <print-tittle v-bind:tittle="`FONDOS DE RENTA FIJA - ${investment.assetName}`" tittleColor="#C2BFE0"></print-tittle>
      <investment-fondos-rf :printableVersion="true" :asset-name="investment.assetName"></investment-fondos-rf>
    </div>
    <!-- Yellow section -->
    <div v-if="portfolioAnalysis.fondosRV.amount > 0" class="new-page third-page">
      <print-tittle tittle="FONDOS DE RENTA VARIABLE" tittleColor="#f8b661"></print-tittle>
      <fondos-rv :printableVersion="true"></fondos-rv>
    </div>
    <!-- Details -->
    <div v-for="(investment, index) in portfolioAnalysis.fondosRV.investments" :key="index" class="new-page">
      <print-tittle v-bind:tittle="`FONDOS DE RENTA VARIABLE - ${investment.assetName}`" tittleColor="#f8b661"></print-tittle>
      <investment-fondos-rv :printableVersion="true" :asset-name="investment.assetName"></investment-fondos-rv>
    </div>
    <!-- Green Section -->
    <div v-if="portfolioAnalysis.capitales.amount > 0" class="new-page fourth-page">
      <print-tittle tittle="CAPITALES" tittleColor="rgb(179, 222, 105)"></print-tittle>
      <capitales :printableVersion="true"></capitales>
    </div>
    <!-- Details -->
    <div v-for="(investment, index) in portfolioAnalysis.capitales.investments" :key="index" class="new-page">
      <print-tittle v-bind:tittle="`CAPITALES - ${investment.assetName}`" tittleColor="rgb(179, 222, 105)"></print-tittle>
      <investment-capitales :printableVersion="true" :asset-name="investment.assetName"></investment-capitales>
    </div>
    <!-- LightBlue Section -->
    <!-- here -->
    <div v-if="portfolioAnalysis.deuda.amount > 0" class="new-page fifth-page">
      <print-tittle tittle="DEUDA" tittleColor="#6FE8D7"></print-tittle>
      <deuda :printableVersion="true"></deuda>
    </div>
    <!-- Details -->
    <div v-for="(investment, index) in portfolioAnalysis.deuda.investments" :key="index" class="new-page">
      <print-tittle v-bind:tittle="`DEUDA - ${investment.assetName}`" tittleColor="#6FE8D7"></print-tittle>
      <investment-deuda :printableVersion="true" :asset-name="investment.assetName"></investment-deuda>
    </div>
    <!-- Marron Section -->
    <div v-if="portfolioAnalysis.estructurados.amount > 0" class="new-page sixth-page">
      <print-tittle tittle="ESTRUCTURADOS" tittleColor="#FB8070"></print-tittle>
      <estructurados :printableVersion="true"></estructurados>
    </div>
    <!-- Investments  -->
    <!-- Legal Notice -->
    <div class="new-page legal-text-section">
      <print-tittle tittle="AVISO LEGAL" tittleColor="#2873de"></print-tittle>
      <p class="legal-text">{{legalNotice}}</p>
    </div>
  </div>
</template>

<script>
import PrintTittle from "./PrintTittle";
import PortfolioOverview from "./PortfolioOverview";
import AssetClassFondosRV from "./AssetClassFondosRV";
import AssetClassFondosRF from "./AssetClassFondosRF";
import AssetClassCapitales from "./AssetClassCapitales";
import AssetClassDeuda from "./AssetClassDeuda";
import AssetClassEstructurados from "./AssetClassEstructurados";
import AssetDetailFondosRF from "./AssetDetailFondosRF";
import AssetDetailFondosRV from "./AssetDetailFondosRV";
import AssetDetailDeuda from "./AssetDetailDeuda";
import AssetDetailCapitales from "./AssetDetailCapitales";
import { getPortfolioAnalysis } from "@/graphql";
import { legalNoticeText } from "@/componentConfig";
export default {
  name: "PrintablePortfolio",
  components: {
    "portfolio-overview": PortfolioOverview,
    // Asset Class views
    "fondos-rv": AssetClassFondosRV,
    "fondos-rf": AssetClassFondosRF,
    deuda: AssetClassDeuda,
    capitales: AssetClassCapitales,
    estructurados: AssetClassEstructurados,
    "investment-fondos-rf": AssetDetailFondosRF,
    "investment-fondos-rv": AssetDetailFondosRV,
    "investment-deuda": AssetDetailDeuda,
    "investment-capitales": AssetDetailCapitales,
    "print-tittle": PrintTittle
  },
  data() {
    return {
      legalNotice: legalNoticeText
    };
  },
  mounted() {
    this.$apollo
      .query({
        query: getPortfolioAnalysis,
        variables: {
          id: this.portofolioId
        },
        fetchPolicy: "cache-first"
      })
      .then(data => this.analysisSuccessHandler(data.data.portfolioAnalysis))
      .catch(error => {
        this.$message({
          type: "error",
          message: "Ocurrió un error intenta más tarde"
        });
      });
  },
  computed: {
    portofolioId: function() {
      return parseInt(this.$route.params.id);
    },
    portfolioAnalysis: function() {
      return this.$store.getters.currentPortfolioAnalysis;
    }
  },
  methods: {
    analysisSuccessHandler(analaysisData) {
      this.$store.dispatch("saveCurrentPortfolioAnalysis", analaysisData);
    }
  }
};
</script>

<style>
/* Style for the print version */
.avoid-page-break {
  page-break-inside: avoid;
}
.avoid-page-break-before {
  page-break-before: avoid;
}
/* Removing padding in the columns so they can fit better */
.new-page .el-col {
  padding-left: 0 !important;
  padding-right: 0 !important;
}
@media print {
  /* GENERAL STYLES */
  /* Recommended settings to be more legible */
  * {
    /* background: yellow !important; */
    -webkit-print-color-adjust: exact;
    print-color-adjust: exact;
    box-shadow: none !important;
    text-shadow: none !important;
  }
  /* Making external links complete urls */
  a[href]::after {
    content: " [" attr(href) "]";
    color: blue;
  }
  /* Adding margin to each page */
  /* Avoid breaking elements between pages */
  ul {
    /* page-break-after: avoid; */
    page-break-inside: avoid;
  }
  /* widows = minimum number of lines in a paragraph split on the new page.
                     orphans = minimum number of lines in a paragraph split on the old page. */
  p {
    widows: 3;
    orphans: 3;
  }
  .el-header {
    display: none;
  }
  .comments-section {
    display: none;
  }
  .footer-container {
    page-break-before: avoid;
    page-break-after: always;
  }
  @page {
    /* Letter size */
    size: 8.5in × 11in;
    margin-top: 1cm;
    margin-right: 0cm;
    margin-bottom: 1cm;
    margin-left: 0cm;
    @top-left {
      content: "";
    }
  }
}
.print-margin-top {
  margin-top: 2em;
}
.printable-porfolio .portfolioHeader-container {
  /* background-color: yellow; */
  padding: 0 !important;
  padding-top: 0em !important;
}
.printable-porfolio .portfolioHeader-container .portfolioHeader-title {
  display: none;
}
.printable-porfolio .new-page .el-col-20 {
  width: 100% !important;
}
.printable-porfolio .border-element {
  display: block !important;
  width: 100%;
  display: none;
  margin: 0 auto;
  border-bottom: 1px solid #bababa;
}
.printable-porfolio .portfolioHeader-subtitles {
  color: #203172 !important;
  font-size: 13px !important;
  margin-top: 10px;
  margin-left: 1.5em;
}
.printable-porfolio .portfolioHeader-navigation {
  padding: 0 6px !important;
  margin-left: 1.2em;
  position: relative;
  z-index: 1;
}
.printable-porfolio .portfolioHeader-navigation .overview-title {
  font-size: 15px !important;
  margin-bottom: 0px !important;
}
.printable-porfolio .portfolioHeader-navigation .overview-amount {
  font-size: 16px !important;
  margin-bottom: 0px !important;
}
.printable-porfolio .portfolioHeader-navigation .overview-porcentage {
  font-size: 10px !important;
}
.printable-porfolio .el-col-7 {
  width: 23% !important;
}
.printable-porfolio .portfolio-logo {
  display: none;
}
.printable-porfolio .portfolioHeader-alias {
  display: block;
  font-size: 13px !important;
  margin-right: 1.2em;
}
/* Styles inside the components */
.second-page > div:nth-of-type(3) .sectionContainer,
.second-page > div:nth-of-type(4) .sectionContainer {
  /* background-color: yellow !important; */
  padding-top: 0 !important;
  /* height: 160px !important; */
}
.second-page > div:nth-of-type(3) .sectionContainer .main-table,
.second-page > div:nth-of-type(4) .sectionContainer .main-table {
  margin-bottom: 0;
}
.third-page > div:nth-of-type(3) .sectionContainer .main-table,
.third-page > div:nth-of-type(4) .sectionContainer .main-table {
  margin-bottom: 0;
}
.fourth-page .printVersion .sectionContainer .main-table {
  margin-bottom: 0 !important;
}
.donnut-chart-section {
  margin-top: -30px !important;
  position: relative;
  z-index: 0;
}
.printable-porfolio .assetClass-container {
  width: 156px;
}
.printable-porfolio .assetClass-container-menu {
  padding: 0px 6px !important;
  height: 61px !important;
}
/* printable version for Fondos RF Cascader */
.printable-porfolio .assetClass-title {
  font-size: 15px !important;
  margin-bottom: 0px !important;
}
.printable-porfolio .assetClass-amount {
  font-size: 16px !important;
  margin-bottom: 0px !important;
}
.printable-porfolio .assetClass-porcentage {
  font-size: 10px !important;
  margin-bottom: 0px !important;
}
/* printable version for 'Emisora de fondo de renta' */
.printable-porfolio .asset-title {
  font-size: 15px !important;
  margin-bottom: 0px !important;
}
.printable-porfolio .asset-amount {
  font-size: 16px !important;
  margin-bottom: 0px !important;
}
.printable-porfolio .asset-porcentage {
  font-size: 10px !important;
  margin-bottom: 0px !important;
}
.printable-porfolio .asset-container-menu {
  padding: 0px 6px !important;
  height: 61px !important;
  width: 156px;
  margin-left: -79px !important;
}
/* Avoid the page-break inside components */
.el-row {
  page-break-inside: avoid;
}
.el-col {
  page-break-inside: avoid;
}
.printVersion .sectionContainer {
  margin-top: 28px;
  page-break-inside: avoid;
}
.legal-text-section .print-tittle span {
  font-size: 24px;
  top: 22px;
}
</style>

<style scoped>
.legal-text {
  line-height: 1.8;
  font-size: 1em;
  text-align: justify;
  padding-top: 2em;
  margin-top: 0px;
  border-top: 1px solid #bababa;
}
.new-page {
  page-break-before: always;
  page-break-after: always;
  /* width: 792px; */
  width: 720px;
  display: block;
  margin: 0 auto;
  /* border: 1px dashed grey; */
  /* min-height: 1062px; */
}
.cover-page {
  min-height: 900px;
  width: 760px;
  margin: 0 auto;
}
.cover-page .header-logo {
  display: block;
  margin: 0 auto;
  width: 460px;
  padding-top: 290px;
}
.cover-page .cover-page-tittle {
  text-align: center;
  border-bottom: 1px solid #e9e9e9;
  padding-top: 130px;
  font-size: 34px;
  font-weight: lighter;
  display: block;
  margin: 0 auto;
  padding-bottom: 10px;
  width: 540px;
}
</style>



// WEBPACK FOOTER //
// src/components/PrintablePortfolioAnalysis.vue